
export enum ETyprOffersShow {
    personalLoan = "personal-loan",
    creditCart = "credit-cards",
    cashDeals = "cash-deals"
}

export const viewOfferByOID = { "personal-loan": ["0"], "credit-cards": ["0"], "cash-deals": ["0"] }
